module.exports = __webpack_public_path__ + "img/app-1024.075fba.png";